import React, { useState } from "react";
import "../styles/TeacherDownloadPage.css";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
// import NoUserHeader from "../components/NoUserHeader";
import home from "../images/home.png"; // Icons for sidebar
import feedback from "../images/feedback.png";
import history from "../images/history.png";
import tutorials from "../images/tutorials.png";
import TeacherDownload from "../components/TeacherDownload";
import Tutorials from "../components/Tutorials";
import TeacherFeedback from "../components/TeacherFeedback";

const TeacherDownloadPage = () => {
  const [activeItem, setActiveItem] = useState("home");
  const [isVideoMode, setIsVideoMode] = useState(true); // Default is the download page
  const [searchQuery, setSearchQuery] = useState("");

  const resetSearch = () => {
    setSearchQuery(""); // Reset the search query
  };

  const teacherMenuItems = [
    { icon: home, label: "Home", key: "home" },
    { icon: feedback, label: "Feedback", key: "feedback", disabled: true },
    { icon: history, label: "History", key: "history", disabled: true },
    { icon: tutorials, label: "Tutorials", key: "tutorials", disabled: true },
  ];

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  // Determine which parts of the header to show based on the active menu item
  const getHeaderVisibility = () => {
    if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    } else if (activeItem === "tutorials") {
      return { showSearch: true, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };

  const renderContent = () => {
    if (activeItem === "home" || activeItem === "") {
      return isVideoMode ? <TeacherDownload /> : <TeacherDownload />;
    } else if (activeItem === "feedback") {
      return <TeacherFeedback />;
    } else if (activeItem === "tutorials") {
      return <Tutorials searchQuery={searchQuery} />;
    } else {
      return <div>Other content...</div>;
    }
  };
  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  return (
    <div className="dashboard">
      <Header
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
      />
      <main className="main-content">
        <Sidebar
          activeItem={activeItem}
          setActiveItem={setActiveItem}
          menuItems={teacherMenuItems}
          resetSearch={resetSearch}
        />
        <div className="content">{renderContent()}</div>
      </main>
    </div>
  );
};

export default TeacherDownloadPage;
